import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'prg-toggle-switch',
  templateUrl: './toggle-switch.component.html',
  styleUrls: ['./toggle-switch.component.less']
})
export class ToggleSwitchComponent implements OnInit {

  @Input() color: string;
  @Input() value: boolean;

  @Output() changed: EventEmitter<boolean>;

  constructor() {
    this.color = '#32b4e5';
    this.changed = new EventEmitter<boolean>();
  }

  ngOnInit() {
  }

  private _clicked() {
    console.log('toggle: clicked');
    this.changed.next(!this.value);
  }

}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/common/toggle-switch/toggle-switch.component.ts